export default [
    {
        path: 'unidade-executante-manutencao',
        component: () => import(
            /* webpackChunkName: 'cadastro-unidade-executante-manutencao' */
            '@/views/cadastro/unidade-executante-manutencao/Index'
        ),
        redirect: 'unidade-executante-manutencao/index',
        children: [
            {
                name: 'cadastro-unidade-executante-manutencao-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'cadastro-unidade-executante-manutencao' */
                    '@/views/cadastro/unidade-executante-manutencao/List.vue'
                ),
            },
            {
                name: 'cadastro-unidade-executante-manutencao-create',
                path: 'create',
                component: () => import(
                    /* webpackChunkName: 'cadastro-unidade-executante-manutencao' */
                    '@/views/cadastro/unidade-executante-manutencao/Form.vue'
                ),
            },
            {
                name: 'cadastro-unidade-executante-manutencao-edit',
                path: 'edit/:id',
                props: route => ({ id: parseInt(route.params.id) }),
                component: () => import(
                    /* webpackChunkName: 'cadastro-unidade-executante-manutencao' */
                    '@/views/cadastro/unidade-executante-manutencao/Form.vue'
                ),
            },
        ],
    },
]